import React from "react";
import styles from "./page-section-layout.module.scss";
import { LayoutStyleTypes } from "@/util-react/layout";

export interface PageSectionLayoutProps {
  type: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM;
  sectionTitle?: string;
  bg?: boolean;
  offsets?: boolean;
  smOffsets?: boolean;
  children?: React.ReactNode;
}

export const PageSectionLayout: React.FC<PageSectionLayoutProps> = ({ type, sectionTitle, bg = true, offsets = true, smOffsets = false, children }) => {
  const boxClass = [
    styles.box,
    bg ? styles.bg : "",
    offsets ? styles.offsets : "",
    smOffsets ? styles.smOffsets : "",
    type === LayoutStyleTypes.TYPE_SM ? styles.sm : "",
  ].join(" ");

  return (
    <div className={boxClass}>
      {sectionTitle && <h2 className={styles.boxTitle}>{sectionTitle}</h2>}
      <div className={styles.boxContent}>{children}</div>
    </div>
  );
};
